"use client"

import { Slash } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SlashIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SlashIcon = component(Icon)({ as: Slash })
